module.exports = __webpack_public_path__ + "assets/img/home_cs_2.4a3bc6b1.png";